import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-datepicker', 'selectDate', 'Pasirinkite datą');
Labels.set('ui-datepicker', 'selectedDate', 'Pasirinkta datą');
Labels.set('ui-datepicker', 'close', 'Uždaryti');
Labels.set('ui-datepicker', 'clear', 'Išvalyti įvestį');
Labels.set(
    'ui-datepicker',
    'invalidFormatHint',
    'Naudokite formatą yyyy-mm-dd, pavyzdžiui 2026-12-24'
);
Labels.set(
    'ui-datepicker',
    'invalidFormatHintLt',
    'Naudokite formatą yyyy-mm-dd, pavyzdžiui 2026-12-24'
);
